const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/middleware/kisapi/translations.ts';
import { defineMessages } from '../../utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        '403': 'Keine ausreichende Berechtigung vorhanden',
        '404': 'Keine Daten vorhanden',
        '504': 'Timeout bei der Serveranfrage',
        generalError: 'Ein Netzwerkfehler ist aufgetreten',
    },
    __RELATIVE_SOURCE_FILE__
);
